import "./TestOrderBasicDetailsViewComponent.scss";
import Grid from "@mui/material/Grid";
import DetailsDataKeyValueComponent from "../../details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import commonService from "../../../services/common.service";
import ChipComponent from "../../chip/ChipComponent";
import {CommonService} from "../../../services";


interface TestOrderBasicDetailsViewComponentProps {
    sample?: any;
}

const TestOrderBasicDetailsViewComponent = (props: TestOrderBasicDetailsViewComponentProps) => {
    const {sample} = props;

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}
                      md={4}
                      xl={4}>
                    <DetailsDataKeyValueComponent
                        title={"Order Type"}> {sample?.orderType || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Reason for visit/testing"}> {sample?.reasonForVisit || 'N/A'} </DetailsDataKeyValueComponent>
                </Grid>
                <Grid item xs={12} sm={12}
                      md={4}
                      xl={4}>
                    <DetailsDataKeyValueComponent
                        title={"External Reference Number"}> {sample?.externalReferenceNumber || 'N/A'}  </DetailsDataKeyValueComponent>
                </Grid>
            </Grid>
            {
                sample?.sample[0]?.medicationDetails?.length > 0 &&
                <Grid container
                      spacing={2}>
                    <Grid item xs={12}
                          sm={12}
                          md={12}
                          xl={12}>
                        <>
                            <DetailsDataKeyValueComponent
                                title={"Medication"}>
                            </DetailsDataKeyValueComponent>
                            <ul className={'medication-list-wrapper'}>
                                {
                                    sample?.sample[0]?.medicationDetails?.map((item: any, index: number) => {
                                        const {
                                            brandName = '',
                                            genericName = '',
                                            dosageForm = '',
                                            dosage = '',
                                            unit = ''
                                        } = CommonService.formatMedicationNames(item);
                                        return <li
                                            key={item.id || index}
                                            className={"medication-list"}>
                                            {brandName} | {genericName} | {dosageForm} | {dosage} | {unit}
                                        </li>
                                    })
                                }
                            </ul>
                        </>
                    </Grid>
                </Grid>
            }
            {
                sample?.isSubmitted === true &&
                sample?.sample?.map((test: any) => {
                    return (
                        <>
                            <div
                                className={'horizontal-line'}></div>
                            <Grid container
                                  spacing={2}>
                                <Grid item
                                      xs={12}
                                      sm={12}
                                      md={4}
                                      xl={4}>
                                    <DetailsDataKeyValueComponent
                                        title={"Test Name"}> {test?.testName ? commonService.capitalizeFirstLetterOfEachWord(test?.testName) : 'N/A'}
                                    </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Order Prioritization Request"}> {test?.isPriorityOrder ? 'Yes' : 'No'} </DetailsDataKeyValueComponent>

                                </Grid>
                                <Grid item
                                      xs={12}
                                      sm={12}
                                      md={4}
                                      xl={4}>
                                    <DetailsDataKeyValueComponent
                                        title={"Barcode (Accession ID)"}>
                                        {test?.barcode || "N/A"}
                                    </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Send Result to Patient"}> {test?.resultSentToPatient ? "Yes" : "No"}  </DetailsDataKeyValueComponent>

                                </Grid>
                                <Grid item
                                      xs={12}
                                      sm={12}
                                      md={4}
                                      xl={4}>
                                    <DetailsDataKeyValueComponent
                                        title={"Collection Date and Time"}>
                                        {test?.dateOfCollection ? commonService.formatDate(test?.dateOfCollection) : 'N/A'} | {test?.timeOfCollection || 'N/A'}
                                    </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Mode of Payment"}> {test?.billingMode || 'N/A'}  </DetailsDataKeyValueComponent>
                                </Grid>
                            </Grid>
                            {test.billingMode === "insurance" && test?.icdCodeDetails && (
                                <>
                                    <DetailsDataKeyValueComponent
                                        title={"ICD Codes"}>
                                        {
                                            test?.icdCodeDetails?.map((item: any) => {
                                                return <ChipComponent
                                                    label={item.icdCode}
                                                    className={"mrg-right-5"}/>
                                            })
                                        }
                                    </DetailsDataKeyValueComponent>
                                </>
                            )}
                            {
                                test.billingMode === 'insurance' && test?.cptCodeDetails?.length > 0 && (
                                    <DetailsDataKeyValueComponent
                                        title={"CPT Codes"}>
                                        {
                                            test?.cptCodeDetails?.map((item: any) => {
                                                return <ChipComponent
                                                    label={item.cptCode}
                                                    className={"mrg-right-5"}/>
                                            })
                                        }
                                    </DetailsDataKeyValueComponent>
                                )
                            }
                        </>
                    )
                })
            }
            {
                sample?.isSubmitted === false && <>
                    <Grid
                        container
                        spacing={2}>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            xl={4}>
                            <DetailsDataKeyValueComponent
                                title={"Test Name"}> {
                                sample?.sample?.map((test: any) => {
                                    return (
                                        <div>
                                            {commonService.capitalizeFirstLetterOfEachWord(test?.testName) || 'N/A'}
                                        </div>
                                    )
                                })}
                            </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            xl={4}>

                            <DetailsDataKeyValueComponent
                                title={"Barcode (Accession ID)"}>
                                {
                                    sample?.sample?.map((test: any) => {
                                        return (
                                            <div>
                                                {test?.barcode || 'N/A'}
                                            </div>
                                        )
                                    })
                                }
                            </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            xl={4}>
                            <DetailsDataKeyValueComponent
                                title={"Collection Date and Time"}>
                                {
                                    sample?.sample?.map((test: any) => {
                                        return (
                                            <div>
                                                {test?.dateOfCollection ? commonService.formatDate(test?.dateOfCollection) : 'N/A'} | {test?.timeOfCollection || 'N/A'}
                                            </div>
                                        )
                                    })}
                            </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>

                </>
            }
        </>
    );

};

export default TestOrderBasicDetailsViewComponent;
